// Kopfdaten je Seite beim Navigieren im Browser nachziehen (2026-11-04).
// Die Erstauslieferung bekommt sie schon von nginx (seo-build.js).
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import cfg from "@/seo-routes.json";

function setMeta(sel, attr, value) {
  let el = document.head.querySelector(sel);
  if (!el && value != null) {
    el = document.createElement(sel.startsWith("link") ? "link" : "meta");
    if (sel.startsWith("link")) el.setAttribute("rel", "canonical");
    else el.setAttribute("name", sel.match(/name="([^"]+)"/)[1]);
    document.head.appendChild(el);
  }
  if (el) el.setAttribute(attr, value);
}

export function metaFor(pathname) {
  const p = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const page = cfg.pages[p];
  const dyn = !page && cfg.dynamic.find((d) => p.startsWith(d.prefix));
  const noindex = (page && page.noindex) || cfg.noindexPrefixes.some((x) => p.startsWith(x));
  return {
    title: (page && page.title) || (dyn && dyn.title) || cfg.default.title,
    description: (page && page.description) || cfg.default.description,
    url: cfg.base + p,
    noindex,
  };
}

export default function RouteMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    const m = metaFor(pathname);
    document.title = m.title;
    setMeta('meta[name="description"]', "content", m.description);
    setMeta('link[rel="canonical"]', "href", m.url);
    setMeta('meta[name="robots"]', "content", m.noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1");
  }, [pathname]);
  return null;
}
